// extracted by mini-css-extract-plugin
export var askAiIcon = "_na-j";
export var category = "_na-9";
export var categoryHeader = "_na-e";
export var container = "_na-0";
export var group = "_na-a";
export var groupItems = "_na-f";
export var groupSeparator = "_na-k";
export var loading = "_na-1";
export var noResults = "_na-3";
export var placeholder = "_na-2";
export var resultContent = "_na-5";
export var resultIcon = "_na-c";
export var resultItem = "_na-g";
export var resultMeta = "_na-8";
export var resultSubtitle = "_na-7";
export var resultSuffix = "_na-i";
export var resultTitle = "_na-6";
export var resultsList = "_na-4";
export var searchGroup = "_na-d";
export var selected = "_na-h";
export var subgroup = "_na-b";